// extracted by mini-css-extract-plugin
export var chip = "_ew-0";
export var filterDropdown = "_ew-5";
export var filterItem = "_ew-6";
export var icon = "_ew-1";
export var removeButton = "_ew-3";
export var removeIcon = "_ew-4";
export var separator = "_ew-2";